export default __webpack_public_path__ + "static/media/inactiveright.9e7fbf5c.svg";